const jobTypes = Object.freeze([
  { value: "A", text: "Full time" },
  { value: "B", text: "Part time" },
  { value: "C", text: "Fixed term contract" }
]);

export default jobTypes;
